'use strict';

angular.module('study.ecrd', [
    'ecrd',
    'ecrd.records',
    'inetsys.modal',
    'route',
    'study.i18n',
]);
